import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
export function ClaridadSection() {
  const [ref, isInView] = useInView({
    threshold: 0.2
  });
  return <section className="py-16 sm:py-32 relative overflow-hidden bg-[#0A0A0B] border-t border-white/5" data-id="element-125">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center relative z-10" data-id="element-126">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} data-id="element-127">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black text-white mb-8 leading-tight" data-id="element-128">
            El problema <span className="text-gold" data-id="element-129">nunca fue el dinero</span>
          </h2>

          <div className="space-y-6 text-lg sm:text-xl text-white/80 font-medium leading-relaxed" data-id="element-130">
            <p data-id="element-131">Fue cómo tu mente fue programada para percibirlo.</p>
            <p data-id="element-132">
              Durante años, tu sistema interno aprendió a operar desde la
              escasez, el esfuerzo constante y la incertidumbre.
            </p>
            <p className="text-white font-bold mt-8" data-id="element-133">
              Y mientras esa programación siga intacta, los resultados no
              cambian.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}